var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.64 54.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M27.32,0C12.23,0,0,12.23,0,27.32s12.23,27.32,27.32,27.32,27.32-12.23,27.32-27.32S42.41,0,27.32,0Zm14.85,39.54c.41,.37,.45,1,.08,1.41-.2,.22-.47,.33-.74,.33-.24,0-.48-.08-.67-.26l-13.78-12.36-13.26,11.89c-.19,.17-.43,.26-.67,.26-.27,0-.55-.11-.74-.33-.37-.41-.33-1.04,.08-1.41l13.1-11.75L12.46,15.57c-.41-.37-.45-1-.08-1.41,.37-.41,1-.45,1.41-.08l13.26,11.89,13.78-12.36c.41-.37,1.04-.33,1.41,.08,.37,.41,.33,1.04-.08,1.41l-13.62,12.22,13.62,12.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.40eac118e07ca7d401ddeec41fd7f7fe.svg";
export { ForwardRef as ReactComponent };